
import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"

import siteMetadata from "./site"

function Seo({ 
  lang, 
  title, 
  metaDescription, 
  metaKeywords, 
  metaElements 
}) {

  const { site } = siteMetadata()
  const actualMetaDescription = metaDescription || site.siteMetadata.description

  var noIndexMetaElements = []
  if (process.env.STAGING) {
    noIndexMetaElements = [{
      name: "robots",
      content: "noindex"
    }]
  }

  var commonMetaElements = [
    {
      name: `description`,
      content: actualMetaDescription,
    },
    {
      property: `og:title`,
      content: title,
    },
    {
      property: `og:description`,
      content: metaDescription,
    },
    {
      property: `og:type`,
      content: `website`,
    },
    {
      name: `twitter:card`,
      content: `summary`,
    },
    {
      name: `twitter:creator`,
      content: site.siteMetadata?.socials?.twitterHandle || ``,
    },
    {
      name: `twitter:title`,
      content: title,
    },
    {
      name: `twitter:description`,
      content: metaDescription,
    },
  ]

  commonMetaElements = commonMetaElements.filter(common => 
    !metaElements.find(extra => 
      (extra['name'] && common['name'] == extra['name']) || 
      (extra['property'] && common['property'] == extra['property'])
    )
  )

  const keywordMetaElements = metaKeywords && metaKeywords.length > 0 ? [{
    name: 'keywords',
    content: metaKeywords.join(', ')
  }] : []

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      meta={commonMetaElements
        .concat(metaElements)
        .concat(noIndexMetaElements)
        .concat(keywordMetaElements)}
    />
  )
}

Seo.defaultProps = {
  lang: `en`,
  metaElements: [],
  metaKeywords: [],
  metaTitle: ``,
  metaDescription: ``,
}

Seo.propTypes = {
  lang: PropTypes.string,  
  title: PropTypes.string.isRequired,  
  metaDescription: PropTypes.string,
  metaKeywords: PropTypes.arrayOf(PropTypes.string),
  metaElements: PropTypes.arrayOf(PropTypes.object),
}

export default Seo
